import React, { useState, useEffect } from "react";
import { getAuth, getUser, isLoggedIn, saveCommonData, saveCurrentServerTime, saveUserAccountData } from "../utils/auth_utils";
import LoginModal from "../login/email_login_modal";
import { getYoutubeVideoId, homeUrl, setWebSocketBaseUrl, success } from "../utils/common_utils";
import IndefiniteProgressBar from "../common_components/indefinite_progress_bar";
import { MSG_ERROR_PROGRESS_UI } from "../common_components/common_ui_components";
import { LinkUIBasic } from "../common_components/common_links";
import { NavbarTop } from "../common_components/navbar_top";
import { useParams } from "react-router-dom";
import QuestionPage from "./question";
import { LuYoutube } from "react-icons/lu";
import { YoutubeVideoDisplay } from "../common_components/youtube_video_display";
import { StartInterviewButton } from "./start_interview_button";
import { getJsonDataPostRequest } from "../utils/network_utils";
import { CUSTOM_GPT_4_OMNI_VOICE_TO_TEXT } from "./question_constants";
import { PiQuestionMarkDuotone } from "react-icons/pi";

const InterviewManager = () => {
  const user=getUser()
  const { questionId } = useParams();
  const [message, setMessage] = useState("");
  const [errorMsg, setErrorMsg]=useState("")
  const [showProgress, setShowProgress]=useState(false)
  const[interviewId, setInterviewId]=useState(-1)
  const [websocketUrl, setWebSocketUrl]=useState("")
  const userLoggedIn=isLoggedIn()
  const [question, setQuestion]=useState(null)
  const[sampleVideoId, setSampleVideoId]=useState("")
  
  const [showQuestionPage, setShowQuestionPage]=useState(false)
  const[showStartInterviewButton, setShowStartInterviewButton]=useState(false)

  function startInterview(){
    setShowStartInterviewButton(false)
    setShowProgress(true)
    let url = homeUrl()+"interviewApi/startNewInterview";
    const data={
      auth:getAuth(),
      questionId:questionId,
      interviewType: CUSTOM_GPT_4_OMNI_VOICE_TO_TEXT
    }
    getJsonDataPostRequest(url, data, function(response){
      setShowProgress(false)
      if(!response){
        setErrorMsg("Some Error Occurred. Please try again")
          return     
      }
        if(!success(response.status)){
          setErrorMsg(response.message || "Some Error Occurred. Please try again")
          return     
        }
        if(!response.interviewId || response.interviewId<=0){
          setErrorMsg("Not able to start interview. Please try again.")
          return
        }
        saveCommonData(response)
        setInterviewId(response.interviewId)
        setWebSocketBaseUrl(response.websocketMachineUrl)  
        setWebSocketUrl(response.websocketMachineUrl)
        setShowQuestionPage(true)
        console.log(response)
    })
   
  }
  
  useEffect(() => {
    console.log("interview manager loaded")
     setShowProgress(true)
     fetchQuestionDetails(questionId, 
        (questionData) => {
          try{
          setShowProgress(false)
             if(!questionData || !questionData.questionId) {
              setErrorMsg("Error in fetching question details. Please try again.")
              return
             }
            setQuestion(questionData)
            console.log(questionData)
            const videoId= getYoutubeVideoId(questionData.sampleVideoUrl)
            console.log("youtube video url and id "+questionData.sampleVideoUrl+" ---> "+videoId+" "+videoId.length)
            if(videoId && videoId.length>0) setSampleVideoId(videoId)
            if(!userLoggedIn) return  
            const showStartButton=userLoggedIn && 
             user.interviewCreditsLeft && 
            user.interviewCreditsLeft>0
            console.log("user logged in "+userLoggedIn+" user credits left "+user.interviewCreditsLeft) 
            console.log("show start interview button "+showStartButton)
            setShowStartInterviewButton(showStartButton)
          // setShowQuestionPage(true)
            //console.log("Success:", data);
        }catch(ex){
          console.log(ex)
        }
        }, 
        (errorMsg) => {
            setShowProgress(false) 
            setErrorMsg(errorMsg)
            console.log("Fail:", errorMsg);
        }
     )

}, []); // empty bracket means there are no dependencies which will make useEffect re run

  return (
    <div>
    {/* on small screens like mobile phones it shows only below  message */}  
    <div className="block md:hidden h-screen w-screen  overflow-hidden
     text-center my-4 mx-4 rounded-lg bg-blue-600 text-white p-4 font-bold">
      <br /> <br />
      Please use Laptop/Desktop or any other large screen for the Mock Interview Session. 
    </div>  
    
    {/* below is the actual UI that user will see on laptop/desktop or any other wide screen */}
    <div className=" flex flex-col h-full w-full
      items-center justify-center ">
      <NavbarTop />
      {showQuestionPage && 
       <QuestionPage question={question} 
          interviewId={interviewId} websocketurl={websocketUrl} />
      }

    {!showQuestionPage &&  
    <div className="flex flex-col w-full h-full  mt-10 items-center justify-center min-w-[60vw] ">

      {/* ***** Top sections started ********** */}
     {question && <div className="mt-16 mb-8  flex flex-col 
      items-center justify-center shadow-md">
        
       { question.heading && question.heading.length>0 &&
        <p className="w-full text-3xl font-bold p-8 px-16 font-mono bg-teal-600 text-white text-center">
          {question.heading} 
       </p>}

       
      <br />  <br />
       { sampleVideoId && sampleVideoId.length>0 &&
       <div className="p-4 md:px-8 md:py-8">
        <YoutubeVideoDisplay videoId={sampleVideoId}/>
        <br />
        <div className="text-gray-700 font-mono">
          Watch above <span className="font-bold text-gray-900 text-xl"> sample mock interview demo video </span>
          to see how it works. </div>
        </div>
        }
      </div>
    }

     {
        !userLoggedIn &&  
        <div className="   text-center items-center- justify-center ">
        <div className="mb-1 text-xl font-mono font-bold">Login to Start the Interview 
          {/* I removed the 'and buy premium part'. Idea is that people will
          login and they will get slightly invested and then they will atleast see
          the premium page where lower prices may entice them to pay and use once. */}
          </div>  
        <br />
        <LoginModal />
        </div>
     }

     { /* double-bang !! forces a true boolean 
     and so the integer value doesn't prints*/
      !! showStartInterviewButton &&
      <div className="leading-10  text-center items-center- justify-center ">
      <StartInterviewButton startInterview={startInterview} />
      </div>
     }

     {
      userLoggedIn && user.interviewCreditsLeft<=0 &&
      <div className="flex flex-col leading-6 text-center
       items-center justify-center
         font-mono ">
        <p className="text-red-500 text-xl font-bold mb-4">
          You do not have enough Interview Credits left </p>
        
        <a href="/premium" className="mr-6 px-6 py-4
        font-normal text-xl font-sans rounded-full
          text-white bg-purple-500 
          hover:bg-purple-600
          ">Buy Interview Credits</a>
       <br />
       <div className="text-sm text-gray-500">
        If you recently bought interview credits.
        Please visit and refresh 
        <LinkUIBasic url="/premium" text="premium" /> page
        
        </div>
        <br />  <br />

        
      </div>
     }

     
     <MSG_ERROR_PROGRESS_UI message={message} 
     error={errorMsg} showProgress={showProgress} />
       <br />  <br />  

     { question && question.description && question.description.length>0 &&
         <div className="text-gray-700 w-full prose
            md:pb-8 min-w-[50vw]"
         dangerouslySetInnerHTML={{ __html: question.description }}>
          </div>
       }
     {question && question.description && question.description.length>0 &&
       <div className="w-full bg-gray-200 h-min-32"><br /> <br /></div>
     }  
        

    </div>
    }
    </div>
    </div>
  )
}

function fetchQuestionDetails(questionId, dataFetched, fail){
    console.log("fetching the question description");
  fetch(homeUrl()+"questionsApi/question/"+questionId, {
    method: "GET"
  })
    .then((response) => response.json())
    .then((data) => {
     // console.log(data)
     // console.log(" "+data.status+"  "+success(data.status))
      if(success(data.status)){
       // console.log(" question description "+data.question.description+" , data description "+data.description)
        if(data.question)data.question["description"]=data.description
        //console.log("assigned question "+data.question.description)
        dataFetched(data.question)
        
      }
      else{
        fail(data.message || "Error in fetching question details, Please try again.")
      }
       // console.log("response received")
       // console.log(data);
    })
    .catch((error) => {
      console.log("exception occured in fetching question details "+JSON.stringify(error));
      fail("Error in fetching question details, Please try again.")
    }); 
}

export {InterviewManager}